import { Typography } from "@circle-react/components/shared/uikit/Typography";
import { ProgressiveImage } from "@circle-react-shared/ProgressiveImage";
import { useTestimonials } from "../hooks/useTestimonials";

export const TestimonialCard = () => {
  const {
    currentTestimonial: { image, imageVariants, content, author, role },
  } = useTestimonials();

  return (
    <div className="flex flex-col items-center space-y-6 text-center">
      <div className="relative">
        <ProgressiveImage
          src={image}
          srcVariants={imageVariants}
          alt={author}
          className="h-20 w-20 rounded-full"
        />
      </div>
      <div className="max-w-[600px] flex-1">
        <Typography.BodyLg color="text-gray-200">{content}</Typography.BodyLg>
        <div className="mt-4">
          <Typography.TitleSm color="text-white">{author}</Typography.TitleSm>
          <Typography.BodySm color="text-white">{role}</Typography.BodySm>
        </div>
      </div>
    </div>
  );
};
